var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("page-header", {
        attrs: {
          actions: _vm.headerActions,
          "left-side-class": "col-xl-4 pb-2",
          page: _vm.headerPage,
          "right-side-class":
            "col-xl-8 align-items-end d-flex pb-4 justify-content-end"
        }
      }),
      _vm.id
        ? _c("board", {
            staticClass: "my-3",
            attrs: { details: _vm.board },
            scopedSlots: _vm._u(
              [
                {
                  key: "data-item",
                  fn: function({ item }) {
                    return [
                      item.status
                        ? _c(
                            "div",
                            [
                              _c("custom-balloon", {
                                attrs: {
                                  "background-color": item.status.color,
                                  dot: "",
                                  text: item.status.name
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e()
                    ]
                  }
                }
              ],
              null,
              false,
              1545991623
            )
          })
        : _vm._e(),
      _c(
        "q-tab",
        {
          attrs: {
            "active-tab": _vm.activeTab.index,
            "nav-class": "text-nowrap",
            "tab-activated": _vm.beforeTabChange
          },
          on: { change: _vm.setTab }
        },
        _vm._l(_vm.tabs, function(tab) {
          return _c(
            "q-tab-item",
            {
              key: tab.id,
              attrs: {
                active: _vm.activeTab.id === tab.id,
                disabled:
                  _vm.activeTab.id !== tab.id &&
                  (_vm.loading ||
                    _vm.isSaving ||
                    _vm.activeTab.options.disabled),
                "has-error": !tab.valid,
                lazy: "",
                "nav-item-class": _vm.navItemClass(tab),
                tabindex: tab.index,
                title: tab.title
              }
            },
            [
              _c(
                "keep-alive",
                [
                  _c(
                    tab.id,
                    _vm._b(
                      {
                        ref: tab.id,
                        refInFor: true,
                        tag: "component",
                        attrs: {
                          id: _vm.id,
                          "appointment-id": _vm.appointmentId,
                          "has-occupational-pairing":
                            _vm.model.hasOccupationalPairing,
                          "is-in-private-school": _vm.isInPrivateSchool,
                          "is-read-only": _vm.isTabReadOnly(tab),
                          "status-id": _vm.model.status?.id,
                          title: tab.title,
                          valid: tab.valid
                        },
                        on: {
                          "signature-status-changed":
                            _vm.handleSignatureStatusChanged,
                          "update:can-complete-signature":
                            _vm.setCanCompleteSignature,
                          "update:disabled": function($event) {
                            tab.options.disabled = $event
                          },
                          "update:has-occupational-pairing":
                            _vm.setHasOccupationalPairing,
                          "update:initialModel": function($event) {
                            return _vm.setInitialModel(tab, $event)
                          },
                          "update:signature-hub-info": _vm.setSignatureHubInfo
                        },
                        model: {
                          value: tab.model,
                          callback: function($$v) {
                            _vm.$set(tab, "model", $$v)
                          },
                          expression: "tab.model"
                        }
                      },
                      "component",
                      tab.options,
                      false
                    )
                  )
                ],
                1
              )
            ],
            1
          )
        }),
        1
      ),
      _vm.canSave
        ? _c(
            "div",
            { staticClass: "d-flex justify-content-end" },
            [
              _c("action-button", {
                attrs: {
                  i: "fas fa-save",
                  text: "Guardar",
                  variant: "success pl-3 pr-3 my-3"
                },
                on: {
                  click: function($event) {
                    return _vm.save()
                  }
                }
              })
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }